<template>
  <div>
    <header>
      <h3>优惠券</h3>
      <p>点击店铺券创建</p>
    </header>
    <div class="content">
      <div class="dianpuquan">
        <div class="logo"></div>
        <div class="text">
          <h3>店铺券</h3>
          <p>适用于全店所有商品</p>
        </div>
        <div class="addBtn">
          <button class="btnn" @click="addNewCoupon">创建</button>
        </div>
      </div>
      <div class="forms">
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item label="店铺名称">
            <el-input
              v-model="name"
              placeholder="请输入店铺名称"
              @blur="panduan()"
            ></el-input>
          </el-form-item>
          <el-form-item label="券有效期">
            <el-date-picker
              v-model="date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item>
            <el-button class="btn" type="primary" @click="getCouponList"
              >查询</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-button class="btn" @click="reset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <el-table :data="list" border style="width: 100%">
      <el-table-column prop="mchName" align="center" width="150" label="店铺名称">
      </el-table-column>
      <el-table-column prop="name" align="center" width="150" label="消费券名称">
      </el-table-column>
      <el-table-column prop="date" align="center" label="券有效期">
      </el-table-column>
      <el-table-column prop="address" align="center" width="150" label="优惠信息">
        <template slot-scope="scope">
          {{ scope.row.amount.toFixed(2) }}元
        </template>
      </el-table-column>
      <!-- <el-table-column prop="address" align="center" label="限领数量"> </el-table-column> -->
      <el-table-column align="center" width="150" label="使用地点"
        >仅限园区内</el-table-column
      >
      <el-table-column prop="companyNames" align="center" label="已发放公司">
      </el-table-column>
      <el-table-column prop="address" align="center" width="150" label="操作">
        <template slot-scope="scope">
          <!-- <el-button @click="handleClick(scope.row)" type="text" size="small"
            >查看</el-button
          > -->
          <el-button type="text" size="small" @click="closeCoupons(scope.row)"
            >关闭</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="block">
      <el-pagination
        layout="prev, pager, next"
        :total="count"
        size="10"
        @current-change="pageFn"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getCoupon, closeCoupon } from "@/api/active/coupon";
export default {
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      list: [],
      count: 1,
      page: 1,
      date: null,
      name: "",
    };
  },
  created() {},
  updated() {},
  mounted() {
    this.getCouponList();
  },
  methods: {
    getCouponList() {
      let that = this;
      let data = {
        current: this.page,
        size: 10,
        mchName: this.name,
      };
      if (this.date == null) {
        console.log(1);
      } else {
        data.stime = this.date[0].getTime();
        data.etime = this.date[1].getTime() - 1 + 24 * 60 * 60 * 1000;
      }
      getCoupon(data).then((res) => {
        this.list = res.data.couponList;
        this.count = res.data.total;
        let a = "";
        this.list.forEach((item) => {
          item.startTime = that.rebuildTime(item.stime);
          item.endTime = that.rebuildTime(item.etime);
          item.date = item.startTime + "至" + item.endTime;
        });
      });
    },
    addNewCoupon() {
      this.$router.push("/main/addCoupon");
    },
    onSubmit() {
      console.log("submit!");
    },
    pageFn(val) {
      this.page = val;
      this.getCouponList();
    },
    reset() {
      (this.name = ""), (this.date = null);
      this.getCouponList();
    },
    panduan() {
      if (this.name == "") {
        this.name = null;
      }
    },
    rebuildTime: function (time) {
      const now = new Date().getTime();
      const date = new Date(Number(time)),
        Y = date.getFullYear(),
        M =
          date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1,
        D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate(),
        h = date.getHours() < 10 ? "0" + date.getHours() : date.getHours(),
        m =
          date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      const dateTimestamp = date.getTime();
      return String(Y).concat("-", M, "-", D, " ", h, ":", m);
    },
    closeCoupons(data) {
      closeCoupon(data.id).then((res) => {
        this.$message({
          message: "关闭成功",
          type: "success",
        });
        this.getCouponList();
      });
    },
    // handleClick(data){
    //   console.log(data.id)
    //   this.$router.push("/main/addCoupon?id=" + data.id);
    // }
  },
};
</script>
<style scoped>
* {
  margin: 0;
  padding: 0;
}
.btn {
  width: 80px;
  height: 40px;
}
header {
  padding: 20px;
  height: 60px;
  border-bottom: 1px solid #eee;
}
.content {
  padding: 20px;
}
.dianpuquan {
  width: 250px;
  height: 60px;
  border: 1px solid #333;
  display: flex;
  padding: 10px;
  position: relative;
}
.dianpuquan:hover .addBtn {
  display: flex;
}
.addBtn {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  display: none;
  align-items: center;
  justify-content: center;
}
.addBtn .btnn {
  width: 100px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  background-color: #fff;
  cursor: pointer;
  outline: none;
  border: none;
}
.dianpuquan .logo {
  width: 40px;
}
.dianpuquan .text {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin-left: 20px;
}
.forms {
  margin: 30px 0;
}
.block {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 50px;
}
</style>



// WEBPACK FOOTER //
// src/pages/salesPromotion/consumerCoupon.vue